module.exports = __webpack_public_path__ + "static/media/downloadCompliance.6a59cd6a.svg";